exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".last-item[data-v-7959b692]{margin-bottom:7rem}@media(min-width: 767px){.last-item[data-v-7959b692]{margin-bottom:4rem}}", ""]);

// exports
